import {inject} from 'acng/core/service/ng.js';
import {post} from 'acng/core/service/backend.js';

import {messengerFeature} from '../config/feature.js';

/**
 * @typedef {import("../model/message").MessageData} MessageData
 * @typedef {import("acng/amateurPool/factory/Amateur").Amateur} Amateur
 */

/**
 * @param {HTMLElement} context
 * @param {Amateur} amateur
 * @param {MessageData} data
 */
export const sendMessage = async (context, amateur, data) => {
  const nickname = amateur.getNickname();

  // TODO(ACNG-????) icebreakerAnswer is a complete fuckup => refactor messenger & dialog model
  const lastMessage = inject('user').guest
    ? undefined
    : await inject('messenger').get(amateur.id).getLastMessage().catch(() => null);

  const {time} = await post(
    'message/send',
    {
      body: data.body,
      recipient: data.recipient,
      price: inject('price').get(amateur),
      attachment_id: data.attachment?.id,
      icebreakerAnswer: lastMessage?.isIcebreaker() ?? false,
    },
    context,
    /** @returns {Promise<{time: number}>} */
    async (error) => {
      if (error.code == -2) {
        error.message = await messengerFeature.translate('signupRequired', {nickname});
      } else if (error.code >= 4000 && error.code < 5000) {
        error.message = await messengerFeature.translate('paymentRequired', {nickname});
      }
      throw error;
    }
  );

  if (lastMessage?.isIcebreaker()) {
    inject('logger')(
      // @ts-ignore
      new (inject('onsLaforgeEvents').IcebreakerResponse)(
        lastMessage.body, //
        lastMessage.payload.ibid,
        amateur.id
      )
    );
  }

  data.time = time * 1000;
};
